<template>
  <div>
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="active">供应商能力申请编辑</span>
    </div>
    <div class="page">
      <div class="title">
        <h2>能力/行业资格申请</h2>
        <div>
          <el-button size="small" @click="onSave()" :loading="loading">保存</el-button>
          <el-button type="primary" size="small" @click="onSave(true)" :loading="loading">保存并提交</el-button>
        </div>
      </div>
      <div>
        <h3>申请信息</h3>
        <el-form :model="dataForm" :rules="dataRule" ref="form">
          <el-form-item label="申请行业：" prop="industry">
            <el-select v-model="dataForm.industry">
              <el-option v-for="item in industryOptions" :key="item.code" :label="item.value"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证明材料：" prop="industryFiles">
            <Upload @success="onAddIndustryFile" />
            <div class="ml-80" v-for="(item, index) in this.dataForm.industryFiles" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveIndustryFile(index)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item label="申请能力：" prop="ability3">
            <el-select filterable class="mr-20" v-model="dataForm.ability1" @change="(val) => getAbilityList(val, 2)">
              <el-option v-for="item in abilityList1" :key="item.id" :label="item.abilityName"
                :value="item.id"></el-option>
            </el-select>
            <el-select filterable class="mr-20" v-model="dataForm.ability2" @change="(val) => getAbilityList(val, 3)">
              <el-option v-for="item in abilityList2" :key="item.id" :label="item.abilityName"
                :value="item.id"></el-option>
            </el-select>
            <el-select filterable v-model="dataForm.ability3">
              <el-option v-for="item in abilityList3" :key="item.id" :label="item.abilityName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证明材料：" prop="proofFiles">
            <Upload @success="onAddProofFile" />

            <div class="ml-80" v-for="(item, index) in this.dataForm.proofFiles" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveProofFile(index)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item label="申请备注：">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="dataForm.remark" style="width: 940px">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from "../component/upload.vue";
import { getDictDataList } from "@/utils";

export default {
  components: {
    Upload,
  },
  data() {
    return {
      loading: false,
      industryOptions: window.SITE_CONFIG.dictList.OMS_OSS_APPLY_INDUSTRY,
      dataForm: {
        industry: "",
        industryFiles: [],
        ability1: "",
        ability2: "",
        ability3: "",
        proofFiles: [],
        remark: "",
      },
      dataRule: {
        industry: [
          { required: true, message: "申请行业不能为空", trigger: "blur" },
        ],
        industryFiles: [
          {
            required: true,
            message: "申请行业证明材料不能为空",
            trigger: "blur",
          },
        ],
        ability3: [
          { required: true, message: "申请能力不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const { ability1, ability2, ability3 } = this.dataForm;
              if (!ability1 || !ability2 || !ability3) {
                callback(new Error("申请能力不能为空"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        proofFiles: [
          {
            required: true,
            message: "申请能力证明材料不能为空",
            trigger: "blur",
          },
        ],
      },
      abilityList1: [],
      abilityList2: [],
      abilityList3: [],
    };
  },
  created() {
    this.getAbilityList("", 1);
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDataSource();
    }
  },
  computed: {
    ssoSupplierId() {
      return this.$store.state.ecology.userInfo.ssoSupplierId;
    },
  },
  methods: {
    getDataSource() {
      this.$http
        .get(`/front/oms/supplierAbilityApply/userApplyAbilityQuery/${this.id}`)
        .then(({ data: res }) => {
          const { code, data } = res;
          if (code === 0) {
            this.dataForm = data;

            this.getAbilityList(data.ability1Code, 2);
            this.getAbilityList(data.ability2Code, 3);
            this.dataForm.ability1 = data.ability1Code;
            this.dataForm.ability2 = data.ability2Code;
            this.dataForm.ability3 = data.ability3Code;
          }
        });
    },
    onSave(submit = false) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { proofFiles, industryFiles, ...other } = this.dataForm;
          const param = {
            ...other,
            ssoSupplierId: this.ssoSupplierId,
            industryFiles: industryFiles.map((i) => {
              return {
                ossId: i.aliOssId || i.ossId,
                fileSize: i.fileSize,
                fileName: i.fileName,
                url: i.url,
              };
            }),
            proofFiles: proofFiles.map((i) => {
              return {
                ossId: i.aliOssId || i.ossId,
                fileSize: i.fileSize,
                fileName: i.fileName,
                url: i.url,
              };
            }),
            ssoSupplierId: this.$store.state.user.defaultCompanyId,
            // 是否直接提交
            submit,
          };
          let url = "";
          if (this.id) {
            param.id = this.id;
            url = `/front/oms/supplierAbilityApply/abilityUpdate`;
          } else {
            url = `/front/oms/supplierAbilityApply/abilityApply`;
          }
          this.loading = true;
          this.$http
            .post(url, param)
            .then(({ data: res }) => {
              const { code, data } = res;
              if (code === 0) {
                this.$message.success("提交成功");
                this.$router.push({
                  name: "ecologicalServices-company-detail",
                  query: {
                    id: this.id || data,
                  },
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("表单验证失败");
        }
      });
    },
    onAddIndustryFile(file) {
      this.dataForm.industryFiles.push(file);
    },
    onRemoveIndustryFile(index) {
      this.dataForm.industryFiles.splice(index, 1);
    },
    onAddProofFile(file) {
      this.dataForm.proofFiles.push(file);
    },
    onRemoveProofFile(index) {
      this.dataForm.proofFiles.splice(index, 1);
    },
    getAbilityList(parentId, level) {
      // 选择变化时，清空下一级选项
      if (level === 2) {
        this.dataForm.ability2 = null;
        this.abilityList2 = [];
        this.dataForm.ability3 = null;
        this.abilityList3 = [];
      } else if (level === 3) {
        this.dataForm.ability3 = null;
        this.abilityList3 = [];
      }
      this.$http
        .post(`/help/oms/abilityDict/list`, { parentId })
        .then(({ data: res }) => {
          const { code, data } = res;
          if (code === 0) {
            switch (level) {
              case 1:
                this.abilityList1 = data;
                break;
              case 2:
                this.abilityList2 = data;
                break;
              case 3:
                this.abilityList3 = data;
                break;
            }
          }
        });
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  padding: 20px;
  min-height: 800px;

  ::v-deep .el-select {
    width: 300px;
  }
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.mr-20 {
  margin-right: 20px;
}

.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;
}

.el-button--primary:hover {
  opacity: 0.9;
}

.flex {
  display: flex;
}

.fileTag {
  margin-bottom: 16px;
  color: #2a54d1;
  background-color: #f1f5fb;

  ::v-deep a {
    color: #2a54d1;
  }
}

.ml-80 {
  margin-left: 80px;
}
</style>